import { format, formatInTimeZone } from 'date-fns-tz'
import ptBr from 'date-fns/locale/pt-BR'

export const formatDate = (date) => {
   return format(date, 'yyyy-MM-dd', {
      locale: ptBr
   })
}

export const formatDateTime = (date) => {
   return format(date, 'yyyy-MM-dd HH:mm', {
      locale: ptBr
   })
}

export const formatTime = (date) => {
   return format(date, 'HH:mm', {
      locale: ptBr
   })
}

export const  formataMinutosParaHHmm = (minutos) => {
  const hora = Math.floor(minutos / 60)
  const minuto = minutos % 60
  return `${String(hora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`
}


export const formatDateTimeView = (date) => {
   return formatInTimeZone(date, 'America/Sao_Paulo', 'dd/MM/yyyy HH:mm:ss', {
      locale: ptBr
   })
}

export const formatDateView = (date) => {
   if (date) {
      return formatInTimeZone(date, 'America/Sao_Paulo', 'dd/MM/yyyy', {
         locale: ptBr
      })
   }
}
export const enviarFormatDateView = (date) => {
   return formatInTimeZone(date, 'America/Sao_Paulo', 'yyyy-MM-dd HH:mm', {
      locale: ptBr
   })
}

export const formatNewDateTimeView = (date) => {
   const dateparams = date ? date : new Date()

   return formatInTimeZone(dateparams, 'America/Sao_Paulo', 'dd/MM/yyyy HH:mm:ss', {
      locale: ptBr
   })
}

